import React from 'react';
import { InoSwitchProps } from './InoSwitch.types';
import { MouseKeyboardEvent } from '../../types';
import { useMappedKeydown } from '../../hooks/useMappedKeydown';

export const InoSwitch: React.FC<InoSwitchProps> = ({
  label,
  isActive = false,
  isChecked = false,
  disabled = false,
  classNames = '',
  variant = 'primary',
  size = 'medium',
  index,
  onChange,
  onLeft,
  onRight,
  onUp,
  onDown,
  onBack,
  onMouseEnter,
}) => {
  useMappedKeydown({
    isActive,
    onOk: e => !disabled && onChange?.(e as any, index),
    onBack,
    onLeft,
    onRight,
    onUp,
    onDown,
    onMouseEnter,
    index,
  });

  return (
    <label
      className={`ino-switch-container ${
        disabled ? 'ino-switch-container--disabled' : ''
      }`}
    >
      <div
        role="switch"
        aria-checked={isChecked}
        aria-disabled={disabled}
        onClick={(e: React.MouseEvent) => {
          if (!disabled && onChange) {
            onChange(e as MouseKeyboardEvent, index);
          }
        }}
        onMouseEnter={(e: React.MouseEvent) => {
          if (onMouseEnter) {
            onMouseEnter(e as MouseKeyboardEvent, index);
          }
        }}
        className={`ino-switch ino-switch--${variant} ino-switch--${size}
          ${isActive ? 'ino-switch--active' : ''}
          ${isChecked ? 'ino-switch--checked' : ''}
          ${disabled ? 'ino-switch--disabled' : ''}
          ${classNames}`}
      >
        <div className="ino-switch__track" />
        <div className="ino-switch__thumb" />
      </div>
      <span className="ino-switch__label">{label}</span>
    </label>
  );
};
